import { City, Country, Province } from "../models/Country";
import { typesenseClient } from "../typesense";

export async function getCountries(): Promise<Country[]> {
    try {
        const results = await typesenseClient
            .collections<Country>("countries")
            .documents()
            .search({
                q: "*",
                limit: 250
            });

        if (!results || !results.hits) {
            return [];
        }

        const items = results.hits!.map(x => x.document);
        return items;
    } catch (e) {
        return Promise.reject("Error fetching countries.");
    }
}

export async function getProvinces(props: { countryId: string }): Promise<Province[]> {
    try {
        const results = await typesenseClient
            .collections<Province>("states")
            .documents()
            .search({
                q: "*",
                filter_by: `countryId:=${props.countryId}`,
                limit: 250
            });

        if (!results || !results.hits) {
            return [];
        }

        const items = results.hits!.map(x => x.document);
        return items;
    } catch (e) {
        return Promise.reject("Error fetching provinces.");
    }
}

export async function getCities(props: { provinceId: string }): Promise<City[]> {
    try {
        const results = await typesenseClient
            .collections<string[]>("cities")
            .documents()
            .export({
                filter_by: `stateId:=${props.provinceId}`
            });

        if (!results) {
            return [];
        }
        
        const lines = results.split('\n');
        const values: City[] = lines.map(x => JSON.parse(x));
        return values;
    } catch (e) {
        return Promise.reject("Error fetching cities.");
    }
}